<div class="card-prodotto" *ngIf="scheda">
  <a [appHref]="urlDettaglio"><img class="square img-fluid mb-2" *ngIf="fotoPrincipale" [appSrcMobileLandscape43]="fotoPrincipale.path" [alt]='fotoPrincipale.alt'/></a>
  <a [appHref]="urlDettaglio"><h6 class="text-stem">{{scheda.titolo}}</h6></a>
  <p class="font-weight-bold">
    <!-- Senza prezzo promo -->
    <span *ngIf="!(scheda.infoCommerciali?.PREZZO_PROMO?.valore)">
      {{scheda.infoCommerciali?.PREZZO?.valore | currency:'EUR'}}
    </span>
    <!-- Con prezzo promo -->
    <span class="sconto mr-4" *ngIf="scheda.infoCommerciali?.PREZZO_PROMO?.valore">
      <span class="sconto mr-4">{{scheda.infoCommerciali?.PREZZO?.valore | currency:'EUR'}}</span>
    </span>
    <span *ngIf="scheda.infoCommerciali?.PREZZO_PROMO?.valore">
      {{scheda.infoCommerciali?.PREZZO_PROMO?.valore | currency:'EUR'}}
    </span>

  </p>


  <div class="row align-items-center">
    <div class="col-6 col-md-9 pr-0" *ngIf="(scheda.infoCommerciali?.PREZZO_PROMO || scheda.infoCommerciali?.PREZZO) && showAcquista">
      <button title="{{'AGGIUNGI_AL_CARRELLO' | translate | htmlToText}}" class="btn btn-stem mr-2" type="button" (click)="aggiungiAlCarrello()" [disabled]="acquistaDisabled">
        <span class="d-none d-lg-block">{{(acquistaDisabled ? 'PRODOTTO_NON_DISPONIBILE' : 'AGGIUNGI_AL_CARRELLO') | translate | htmlToText}}</span>
        <i class="fas fa-shopping-cart icon-single d-lg-none"></i>
      </button>
    </div>
    <div class="col-6 col-md-3 text-center pl-0" *ngIf="isLoggedIn">
      <!-- QUANDO IL PRODOTTO VIENE AGGIUNTO AI PREFERITI, SI AGGIUNGE LA CLASSE .ACTIVE CHE SI RIMUOVE UNA VOLTA TOLTO DAI PREFERITI -->
      <a (click)="aggiungiAiPreferiti()"><i class="fas fa-heart" [class.active]="isPreferito"></i></a>
    </div>
  </div>
</div>
